/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { useRouter } from 'next/router'
import React from 'react'
import { CardProps } from 'src/common/components/Card'
import { FilterBar } from 'src/common/components/FilterBar'
import { HeroBanner } from 'src/common/components/HeroBanner'
import { Lane } from 'src/common/components/Lane'
import { AppLayout } from 'src/common/components/Layout/AppLayout'
import { EVENT_TYPE } from 'src/common/constants/eventTypes'
import { useIsLoggedIn } from 'src/common/hooks/useIsLoggedIn'
import { prependAssetHost, prependAssetHostChallenge } from 'src/common/utils'
import { DiscoverLaneRes, getAllMerch, getLanes } from 'src/services/mainAPI'
import { Challenge } from 'src/services/types/searchEvents'
import { wrapper } from 'src/store'

type StorePageProps = {
    initialLoggedInStatus: boolean
    allMerch: Challenge[]
    storeLanes: DiscoverLaneRes
}

const StorePage = ({ allMerch, storeLanes }: StorePageProps) => {
    const router = useRouter()
    const isLoggedInSSR = useIsLoggedIn()
    const firstMerch = allMerch?.filter((r) => r.isPrivateChallenge !== true)[0] ?? null
    // const { data: allMerch } = mainApi.endpoints.getAllMerch.useQueryState(null)

    return (
        <AppLayout
            initialLoggedInStatus={false}
            pageTitle="Store"
            metaTitle="Need something to help you on your fitness journey? We got your back. | Yes.Fit"
        >
            <HeroBanner
                isLoggedIn={isLoggedInSSR}
                bgImage={null}
                buttonText={{
                    loggedIn: 'Buy It Now',
                    loggedOut: 'Buy It Now'
                }}
                description={''}
                onButtonClick={() => {
                    void router.push(`/store/${firstMerch.challengeUrl}`)
                }}
                rightImage={prependAssetHostChallenge(firstMerch.logo)}
                subtitle={`$${firstMerch.minimumPrice}`}
                title={firstMerch.name}
                type="merch"
                darkTitle
            />

            <FilterBar />

            {storeLanes?.lanes?.map((lane, idx) => {
                return (
                    <section className="mt-12 mb-10 pl-3 md:pl-0" key={idx}>
                        <Lane
                            titleIconComponent={() => (
                                <i
                                    aria-hidden
                                    style={{ color: 'rgb(255, 124, 109)' }}
                                    className="fas fa-shopping-cart text-xl leading-none"
                                ></i>
                            )}
                            title={lane.name}
                            data={
                                lane?.challengeLanes
                                    ?.filter((i) => i.challenge !== null)
                                    .map((mItem): CardProps => {
                                        return {
                                            cardType: 'merch',
                                            featured: false,
                                            imageURL: mItem.challenge.logo
                                                ? prependAssetHostChallenge(
                                                      mItem.challenge.logo
                                                  )
                                                : prependAssetHost('/icons/no-swag.png'),
                                            price: `$${mItem.challenge.minimumPrice}`,
                                            title: mItem.challenge.name,
                                            href: `/store/${encodeURIComponent(
                                                mItem.challenge.challengeUrl
                                            )}`
                                        }
                                    }) ?? []
                            }
                        />
                    </section>
                )
            })}
        </AppLayout>
    )
}

export const getServerSideProps = wrapper.getServerSideProps((store) => async () => {
    const { data: allMerch } = await store.dispatch(getAllMerch.initiate(null))
    const { data: storeLanes } = await store.dispatch(getLanes.initiate(EVENT_TYPE.SWAG))

    const state = store.getState()

    return {
        props: {
            initialLoggedInStatus: state.user.data !== null,
            allMerch,
            storeLanes: storeLanes ?? []
        }
    }
})

export default StorePage
